import { opportunityData } from "configs/opportunity.config";
import { SubAssetType } from "pages/application/opportunities/edit/loanDetails/elements/overview/subAssetType/SubAssetType";
import { Col, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { Dropdown, Input, Radio, RadioGroup } from "stories";
import { currencyRules } from "utils/customHooks/currencyFormat";

const LoanDetailsSection = () => {
  const form = useFormContext();
  const { errors } = form.formState;

  return (
    <>
      <Row>
        <Col>
          <Controller
            name="loan_details.amount_requested"
            control={form.control}
            rules={{
              ...currencyRules,
              required: true,
            }}
            render={({ field }) => {
              return (
                <Input
                  label={"Amount Requested"}
                  placeholder={"Input Here"}
                  type="currency"
                  step="0.01"
                  startAdornment="$"
                  {...field}
                  require
                  value={field.value || ""}
                  error={errors?.loan_details?.amount_requested?.message}
                />
              );
            }}
          />
        </Col>
        <Col>
          <Dropdown
            label={"Loan Type"}
            placeholder={"Input Here"}
            required
            fullWidth
            flat
            list={opportunityData.loanTypeList}
            {...form.register("loan_details.loan_type")}
          />
        </Col>
        <Col>
          <Dropdown
            label={"Mortgage Position"}
            placeholder={"Input Here"}
            required
            fullWidth
            flat
            list={opportunityData.financingTypeList}
            {...form.register("loan_details.mortgage_position")}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Controller
            control={form.control}
            name="loan_details.refinance_loan"
            render={({ field }) => {
              const { onChange, ...props } = field;
              return (
                <RadioGroup groupLabel={"Refinance Loan"}>
                  <Radio
                    label={"Yes"}
                    onChange={() => onChange(true)}
                    checked={field.value === true}
                    {...props}
                  />
                  <Radio
                    label={"No"}
                    onChange={() => onChange(false)}
                    checked={field.value === false}
                    {...props}
                  />
                </RadioGroup>
              );
            }}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <span className="text-sm">Sub Asset Type</span>
        <div>
          <div className={`mt-2 px-4 bg-input`}>
            <SubAssetType objKey="loan_details.asset_classes" />
          </div>
        </div>
      </Row>
    </>
  );
};

export default LoanDetailsSection;
